module.exports = __webpack_public_path__ + "static/media/print.c9ef42ea.svg";